'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = partition;

var _immutable = require('immutable');

function isReducible(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.reduce === 'function';
}

function checkReducible(obj) {
  if (!isReducible(obj)) {
    throw new Error('the data structure is expected to have a `reduce` function');
  }
}

function partition(keyForValue, reducible) {
  if (typeof keyForValue !== 'function') {
    throw new Error('keyForValue must be a function, got: ' + (typeof keyForValue === 'undefined' ? 'undefined' : _typeof(keyForValue)));
  }

  var reduceFn = function reduceFn(partitions, item) {
    var key = keyForValue(item);

    if (typeof key !== 'string') {
      throw new Error('keyForValue must return a string, got: ' + (typeof key === 'undefined' ? 'undefined' : _typeof(key)));
    }

    var partition = partitions.get(key) || (0, _immutable.List)();
    return partitions.set(key, partition.push(item));
  };

  function partial(reducible) {
    checkReducible(reducible);
    return reducible.reduce(reduceFn, (0, _immutable.Map)());
  }

  return reducible ? partial(reducible) : partial;
}